import { useEffect, useState } from "react";
import { supabase } from "../lib/supabase";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "sending" | "sent" | "error">("idle");
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    document.body.classList.add("light");
    return () => { document.body.classList.remove("light"); };
  }, []);

  const send = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus("sending");
    const { error } = await supabase.auth.signInWithOtp({
      email,
      options: { emailRedirectTo: window.location.origin },
    });
    if (error) {
      setStatus("error");
      setErrorMsg(error.message);
    } else {
      setStatus("sent");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="w-full max-w-md fade-up">
        <div className="text-center mb-10">
          <div className="text-sm tracking-[0.32em] text-teal font-medium uppercase mb-3 font-sans">Yvree</div>
          <h1 className="font-serif text-5xl text-textPrimary font-light leading-tight">
            <span className="italic">LifeScribe</span>
          </h1>
          <p className="text-textBody mt-3 text-sm font-sans">Your personalized wellness intelligence.</p>
        </div>

        <div className="bg-white rounded-2xl border border-cardBorder p-8 shadow-sm">
          {status === "sent" ? (
            <div className="text-center py-4">
              <div className="text-teal text-sm tracking-wider uppercase mb-3 font-sans">Check your email</div>
              <p className="text-textBody text-sm leading-relaxed font-sans">
                We sent a magic link to <strong className="text-textPrimary">{email}</strong>. Tap it to sign in.
              </p>
              <button
                onClick={() => { setStatus("idle"); setEmail(""); }}
                className="mt-6 text-xs text-textBody hover:text-teal underline-offset-2 hover:underline font-sans"
              >
                Try a different email
              </button>
            </div>
          ) : (
            <form onSubmit={send} className="space-y-5">
              <label className="block">
                <span className="text-xs tracking-wider uppercase text-textBody font-medium font-sans">Email address</span>
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="mt-2 w-full px-4 py-3 bg-cream border border-cardBorder rounded-lg text-textPrimary focus:border-teal focus:outline-none focus:ring-2 focus:ring-teal/20 transition font-sans"
                  placeholder="you@example.com"
                  autoFocus
                />
              </label>

              <button
                type="submit"
                disabled={status === "sending"}
                className="w-full bg-teal hover:bg-tealDeep disabled:opacity-50 disabled:cursor-not-allowed text-white tracking-wider uppercase text-xs font-medium py-3.5 rounded-lg transition-colors font-sans"
              >
                {status === "sending" ? "Sending…" : "Send Magic Link"}
              </button>

              {status === "error" && (
                <div className="text-coral text-sm text-center font-sans">{errorMsg}</div>
              )}
            </form>
          )}
        </div>

        <p className="text-center text-xs text-textBody mt-6 leading-relaxed font-sans">
          By signing in, you agree to Yvree's Terms of Service and Privacy Policy.
        </p>
      </div>
    </div>
  );
}
